<template>
  <!-- 揭西县人民医院 -->
  <div class="pageContent">
    <img src="../../../assets/jiexi.png" alt="Login logo" class="loginLogo" />
    <div class="hosName">揭西县人民医院</div>
    <div class="ourterTitle">
      输入身份证号/就诊卡号/门诊号/住院号绑定数字影像
    </div>
    <div class="bindDetails">
      <div class="IDNumber">
        <van-field
          v-model="name52200003"
          placeholder="请输入绑定信息"
          @input.native="inputFn"
        />
      </div>
      <footer class="footer">
        <van-button type="primary" :disabled="rules" @click.native="nextFn"
          >下一步</van-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import { bind, dockCheckCaptcha } from "@/api/login";
import Storage from "@/tools/storage";
export default {
  data() {
    return {
      name52200003: "",
      rules: true,
    };
  },
  methods: {
    inputFn() {
      if (this.name52200003 != "") {
        this.rules = false;
      } else {
        this.rules = true;
      }
    },
    nextFn() {
      let institution_id = window.location.href.split("/checkInfoOuter/")[1];
      window.localStorage.setItem("name52200003", this.name52200003);
      window.localStorage.setItem("institution_id", institution_id);
      this.$router.push({
        path: "/reportListOuter",
      });
    },
  },
  created() {
    window.localStorage.clear();
    let institution_id = window.location.href.split("/checkInfoOuter/")[1];
    if (window.localStorage.getItem("name52200003")) {
      this.$router.push({
        path: "/reportListOuter",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.hosName {
  font-size: 20px;
  padding: 10px 0;
  font-weight: 800;
}
.ourterTitle {
  padding: 15px 0 20px;
  font-size: 18px;
  font-weight: 500;
}
.bindDetails {
  width: 90%;
  margin: 0 auto;
}
</style>
